type PercentProps = {
  number: number
}

const Percent = ({ number }: PercentProps): JSX.Element => {
  return <span>{Math.round(number * 100) / 100}%</span>
}

export default Percent
